import { Link } from "react-router-dom";

const BRAND_LOGO_URL = "https://storage.readdy-site.link/project_files/7340c102-b00e-4c74-80d1-988e660b490c/56518e71-1d48-4e5f-bd4e-2dd6f383c43a_compressed_HL.webp";

interface LogoProps {
  variant?: "light" | "dark";
  className?: string;
}

export default function Logo({ variant = "dark", className = "" }: LogoProps) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`}>
      <img
        src={BRAND_LOGO_URL}
        alt="Hackers Lodge"
        className="w-9 h-9 md:w-10 md:h-10 rounded-lg object-cover flex-shrink-0"
      />
      <div className="flex flex-col">
        <span className={`text-lg md:text-xl font-bold tracking-tight leading-none transition-colors duration-300 ${
          variant === "dark" ? "text-gray-100" : "text-white"
        }`}>
          HACKERS
        </span>
        <span className={`text-[10px] md:text-[11px] font-semibold tracking-[0.25em] leading-none mt-0.5 transition-colors duration-300 ${
          variant === "dark" ? "text-[#5cb85c]" : "text-white/80"
        }`}>
          LODGE
        </span>
      </div>
    </Link>
  );
}